// extracted by mini-css-extract-plugin
export var defaultWrapper = "_mo-3";
export var downloadButton = "_mo-4";
export var fileContainer = "_mo-9 _mo-7";
export var fileContainerBase = "_mo-7";
export var fileContainerFixedHeight = "_mo-8 _mo-7";
export var fileInfo = "_mo-5";
export var fileInfoWidthRestricted = "_mo-6";
export var fileType = "_mo-1";
export var fileTypeName = "_mo-2";
export var image = "_mo-0";
export var link = "_mo-b";
export var overflowEllipsis = "_mo-a";